import * as React from 'react';
import { useSelector } from 'react-redux';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { selectBreadcrumbs } from '../../selectors/villages';

interface IBreadcrumbsContainerProps {
  divider?: React.ReactNode;
}

export const BreadcrumbsContainer: React.FC<IBreadcrumbsContainerProps> = ({ divider }) => {
  const breadcrumbs = useSelector(selectBreadcrumbs);

  if (!breadcrumbs.length) {
    return null;
  }

  return <Breadcrumbs breadcrumbs={breadcrumbs} divider={divider} />;
};
